/**
 * ActionIcon
 *
 * Shared icon resolver for the Page Action UI components.
 * Resolves a PageAction's `icon` string to a renderable element.
 *
 * Supports:
 *   - Emoji strings (rendered as-is)
 *   - Lucide icon names, PascalCase or kebab-case (rendered as the icon)
 *
 * Shared by PageToolbar and CommandPalette.
 */

import { Icon } from '../Icon';

export interface ActionIconProps {
  /** Icon identifier — emoji or Lucide name (PascalCase or kebab-case) */
  icon?: string;
  /** Render size in px (default 16) */
  size?: number;
  /** Additional className */
  className?: string;
}

/**
 * Renders a page action icon through the app's Icon: an emoji as-is, a
 * Lucide name ("Plus", "FolderOpen", "folder-open") as that icon. A name
 * that is neither renders nothing — never the name itself as text.
 */
export function ActionIcon({ icon, size = 16, className }: ActionIconProps) {
  if (!icon) return null;
  return <Icon name={icon} size={size} colorful={false} className={className} fallback="none" />;
}

export default ActionIcon;
